import axios from 'axios';
import { Platform } from 'react-native';


const API_URL = 'https://kasir.mb888.web.id';
// const API_URL = 'http://192.168.1.10:8000';
// const API_URL = 'http://192.168.1.4:8000';

interface LoginData {
    username: string;
    password: string;
}

export interface UserModel {
    id: number;
    name: string;
    username: string;
    avatar: string;
}

export interface AttendanceStatus {
    message: string;
    status: string;
    time_in: string;
    checkin: boolean;
    checkout: boolean;
    photo_in: string;
    photo_out: string;
}

export interface LoginResponse {
    token: string;
    token_type: string;
    user: UserModel;
}

export const login = async (data: LoginData): Promise<LoginResponse> => {
    console.log('Request Login API');
    let url = API_URL + '/api/attendance/login';
    return axios.post<LoginResponse>(url, data).then(response => {
        return response.data;
    });
};

export const getUser = (token: string): Promise<UserModel> => {
    console.log('Request GetUser API');
    let url = API_URL + '/api/attendance/staff';
    return axios.get<UserModel>(url, {
        headers: {
            authorization: `Bearer ${token}`
        }
    }).then(response => {
        return response.data;
    })
}

export const getAttendanceStatus = (token: string): Promise<AttendanceStatus> => {
    console.log('Request Status API');
    let url = API_URL + '/api/attendance/status';
    return axios.get<AttendanceStatus>(url, {
        headers: {
            authorization: `Bearer ${token}`
        }
    }).then(response => {
        return response.data;
    })
}

export const postCheckin = (token: string, device: string, latitude: string, longitude: string, photo: string): Promise<{}> => {
    console.log('Request Checkin API');
    let url = API_URL + '/api/attendance/checkin';

    let formData = new FormData();
    formData.append('device', device);
    formData.append('latitude', latitude);
    formData.append('longitude', longitude);
    if (Platform.OS == 'web') {
        formData.append('photo', photo);
    } else {
        formData.append('photo', { uri: Platform.OS == 'android' ? photo : photo.replace('file://', ''), name: 'photo.jpg', type: 'image/jpeg' });
    }

    return axios.post(url, formData, {
        headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    }).then(response => {
        return response.data;
    });
}

export const postCheckout = (token: string, device: string, latitude: string, longitude: string, photo: string): Promise<{}> => {
    console.log('Request Checkout API');
    let url = API_URL + '/api/attendance/checkout';

    let formData = new FormData();
    formData.append('device', device);
    formData.append('latitude', latitude);
    formData.append('longitude', longitude);
    if (Platform.OS == 'web') {
        formData.append('photo', photo);
    } else {
        formData.append('photo', { uri: Platform.OS == 'android' ? photo : photo.replace('file://', ''), name: 'photo.jpg', type: 'image/jpeg' });
    }


    return axios.post(url, formData, {
        headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    }).then(response => {
        return response.data;
    });
}

